<template>
  <div v-loading="loading" element-loading-text="企业名片生成中...">
    <div class="flex space-between pl10 pr20">
      <!-- <el-breadcrumb separator="/" style="margin: 0 0 .3rem;">
        <el-breadcrumb-item>邀请函模板</el-breadcrumb-item>
      </el-breadcrumb> -->
    </div>
    <!-- <div class="createbox"><a href=" https://www.exporegist.com/ExpoCube/DataFile/StampImg/CCagrochem/1765/Img_1765_243.jpg"  class="createbtn" download="img">下载</a> </div>

   -->
   <!-- https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/image-file/mianliao/386360_1698212995601.jpg -->

   <!-- https://www.exporegist.com/ExpoCube/DataFile/StampImg/CCagrochem/1765/Img_1765_250.jpg -->
    <!-- <div class="createbox" @click="downloadByData('https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/image-file/mianliao/386360_1698212995601.jpg')">下载 </div> 

    <div class="createbox" @click="downloadByData('https://www.exporegist.com/ExpoCube/DataFile/StampImg/CCagrochem/1765/Img_1765_250.jpg')">下载 11</div>  -->
    <!-- <div style="margin: 10px 0;">请选择邀请函模板:</div> -->
    <template>
      <div style="margin: 2%;">
        <el-form>
          <template >
            <el-form-item label="企业名片使用名称:">
              <el-radio-group v-model="ComShowField" @change="changeRadio">
                <el-radio label="q">公司全称</el-radio>
                <el-radio label="s">公司简称</el-radio>
              </el-radio-group>
            </el-form-item>
          </template>
          <!-- <el-button size="medium" type="primary" :style="buttonStyle" @click="onSubmit">生成</el-button> -->
        </el-form>
      </div>
      <div class="wrapClass">
        <!-- @click="activeFun(item,index)" -->
        <div class="listCss" v-for="(item,index) in listArr" :key="index"  >
          <div class='imgBox'>
            <div style="height:100%;display:flex;align-items:end">
              <img :src="item.invitationImgUrl" />
            </div>
          </div>
          <!-- <div class="createbox" @click="downloadByData(item.invitationHtmlUrl)">下载 </div> -->
          <!-- <div class="createbox" @click="downloadByData(item.invitationImgUrl)">下载 </div> -->
          <div class="createbox"><a :href="item.invitationImgUrl"  class="createbtn" download="" target="_blank" >下载</a> </div>
        </div>
      </div>
		</template>
    <!-- <div class="createbox"><span class="createbtn" @click="createYqh">创建邀请函</span></div> -->
      <div v-show="showMZ" class="tc" id="mz">
        <div style="border-bottom: 1px solid #EFEFEF; padding:10px 15px; font-size: 16px;">邀请函模板【请使用微信扫描二维码】</div>
        <div style="border-bottom: 1px solid #EFEFEF; text-align: center; padding:20px 0; font-size: 18px;">请扫描下方二维码获得企业专属邀请函</div>
        <div>
          <div class="qrcode" id="qrcode" ref="qrcode" style="width: 100%; margin-top: 10px; text-align: center;"></div>
          <ul style="width: 80%; margin: 10px auto;">
            <li style="font-weight: bold; list-style: outside;">手机端操作请先截图此页面保存至相册，退出系统后，在微信界面点击右上角“+”下的扫一扫，选择相册里的截图识别二维码生成邀请函，即可转发给客户或发送至朋友圈。在电脑端登录此系统的可直接用手机扫上述二维码生成邀请函转发。</li>
            <li style="list-style: outside;">发送前请检查邀请函显示内容，如需修改请关闭本窗口，并返回上传展商信息页面修改。
						<li style="list-style: outside;">在<strong style="color: red;">生成的邀请函</strong>界面点击右上角三个点，选择您要转发的微信好友，或者发送至朋友圈。提醒您的客户点击邀请函上的“马上预登记”按钮提交个人实名制信息，即可获得参观证件。</li>
						<li style="list-style: outside;">您可通过“邀请观众列表”菜单随时查看已登记客户信息。请提醒客户，参观展会必须随身携带身份证件原件，国内观众入场时须刷身份证过闸机验证。海外观众需在登录柜台人工查验核对证件信息方可入场。</li>
            <li style="list-style: outside;">如在操作过程遇到任何问题，请致电010-85229831/85229496咨询。</li>
          </ul>
        </div>
        <div @click="close" style="width: 10%; cursor: pointer; text-align: center; background: #409EFF; color: #FFFFFF; margin:20px auto;">关闭</div>
      </div>
  </div>
</template>
<script>
import api from '@/api'
import img1 from '../../assets/1.png';
import img2 from '../../assets/2.png';
import img3 from '../../assets/1.png';
import QRCode from 'qrcodejs2'

export default {
  data(){
      return{
        activeVar:3,
        listArr: [],
        qrcode: '',
        showMZ: false,
        loading:true,
        atrID: localStorage.getItem('atrID'),
        bthCode: localStorage.getItem('bthCode'),
        loginName: localStorage.getItem('loginName'),
        ewmText: '',
        invitationTheme:"",
        ComShowField: "q",  // s简称  ,q全称
        buttonStyle: sessionStorage.getItem('buttonStyle') ? JSON.parse(sessionStorage.getItem('buttonStyle')) : {},
      }
  },
  components: {},
  mounted() {
    // console.log(this.loginName.split('-'))
    if(this.loginName.indexOf('-')>-1){
      this.invitationTheme = this.loginName.split('-')[0]
    }
    this.geInvitation()
  },
  methods: {
    changeRadio(){
      this.onSubmit()
    },
    onSubmit() {
      this.listArr = []
      this.loading = true
      this.geInvitation()
    },
    open () {
      this.showMZ = true
    },
    close () {
      this.showMZ = false
    },
    activeFun(item,index){
        // item 为被选中的元素体
        this.activeVar=index
    },
    geInvitation(){
      api.generateinvitationletters({
        imgWidth:750,
        invitationTheme:this.invitationTheme,
        dataSources:'catalog',
        ComShowField: this.ComShowField
      }).then((res)=>{
        if(res.data.code == '200'){
          res.data.data.map(item => {
            // console.log(`${item.invitationImgUrl}?timestamp=${new Date().getTime()}`)
            item.invitationImgUrl = `${item.invitationImgUrl}?timestamp=${new Date().getTime()}`
          })
          this.listArr = res.data.data
        }
        // console.log(this.listArr,'this.listArr')
        this.loading = false;
      })
    },
    createYqh(){
      if(this.activeVar == 3){
        alert('请选择邀请函模板')
      }else{
        if(this.listArr[this.activeVar].tempId == '570'){
          this.ewmText = 'https://vis.eastfair.com/Public/wtt/23jfFx/index1.html?atrID=' + this.atrID + '&dbname=' + this.listArr[this.activeVar].dbName + '&tmpid=' + this.listArr[this.activeVar].tempId + '&bthCode=' + this.bthCode + '&language=' + 'en'
        }else{
          this.ewmText = 'https://vis.eastfair.com/Public/wtt/23jfFx/index1.html?atrID=' + this.atrID + '&dbname=' + this.listArr[this.activeVar].dbName + '&tmpid=' + this.listArr[this.activeVar].tempId + '&bthCode=' + this.bthCode + '&language=' + 'cn'
        }
        this.showMZ = true
        document.getElementById("qrcode").innerHTML = ""
        this.qrcode = new QRCode('qrcode', {
          width: 150,
          height: 150,
          //this.listArr[this.activeVar].tempId
          text: this.ewmText
        })
      }
    },

    downloadByData (url) {
      var _urlName = ''
      var _urlArr = []
      if(url){
        _urlArr = url.split('/')
        _urlName = _urlArr[_urlArr.length-1]
      }

      let image = new Image()  //创建图片对象
      image.setAttribute('crossOrigin', 'anonymous') //设置允许跨域
      image.src = url //赋值src
      image.onload = () => {
        //等待图片加载完成创建canvas
        let canvas = document.createElement('canvas')
        //将图片绘制到canvas画布上
        canvas.width = image.width
        canvas.height = image.height
        let ctx = canvas.getContext('2d')
        ctx.drawImage(image, 0, 0, image.width, image.height)
        //获取图片文件格式  jpg/jpeg/png
        let ext = image.src.substring(image.src.lastIndexOf('.')+1).toLowerCase()
        //导出画布快照  此时已越过跨域限制成功取到图片数据
        let dataURL = canvas.toDataURL('image/' + ext)
        //创建a标签
        const a = document.createElement("a");
        // 赋值a标签download属性值，标明该a标签提供下载功能，同时该属性指定了下载时的文件名称
        a.download = _urlName;
        //赋值a标签下载地址，即canvas导出的画布快照 base64格式的图片地址
        a.href = dataURL;
        //添加a标签到dom中
        document.body.appendChild(a);
        //触发a标签点击事件 触发下载
        a.click();
        //下载完成 删除多余的a标签  保持页面原有元素不动
        document.removeChild(a);
      }
    },
  }
}
</script>
<style lang="less">
.el-radio{
	width: 30% !important;
	position: relative;
}
.bor{
	border: #409EFF;
}
.el-radio__input{
}
.el-radio__label{
	width: 100%;
	display: inline-block;
}
.el-radio__label img{
	width: 100%; 
	display: inline-block;
}
.wrapClass{
	width: 100%;
	overflow: hidden;
  display: flex;
  flex-wrap: wrap;
}
.wrapClass p{
	line-height: 0.5rem;
}
.listCss{
	float: left;
	margin: 0 2%;
  cursor: pointer;
  width: 18%;
  text-align: center;
  display: flex;
  flex-direction: column;
}
.listCss img{
	display: inline-block;
  width: 100%;
}
.listCss p{
	font-size: 0.15rem;
	font-weight: bold;
	color: #409eff;
}
.activeCss{
 border: 3px solid #409eff;
}
.qrcode img{
	margin: 0 auto;
}
.createbox{
  width: 100%;
  text-align: left;
  padding-bottom: 100px;
  padding-top:20px;
  text-align:center;
  .createbtn{
    cursor: pointer;
    margin: 0px auto;
    display: inline-block;
    width: 50%;
    background: rgb(64, 158, 255);
    color: rgb(255, 255, 255);
    padding: 10px;
    font-size: 14px;
    border-radius: 5px;
    text-decoration:none;
    text-align: center;
  }
}
.tc{
  position: fixed;
  z-index: 100;
    background: rgb(255, 255, 255);
    top: 0px;
    left: 25%;
    width: 50%;
    box-sizing: border-box;
    height: auto;
    border: 1px solid rgb(239, 239, 239);
    border-radius: 10px;
    margin: 2%;
    color: rgb(0, 0, 0);
    text-align: justify;
    line-height: 26px;
}
.imgBox{
  width:100%;
  flex: 1;
}
.imgBox img{
  vertical-align: top;
}
@media screen and (max-width:540px){
  .listCss{
    margin: 2%;
    cursor: pointer;
    width: 95%;
    text-align: center;
  }
  .listCss p{
    font-size: 0.45rem;
    font-weight: bold;
    color: #409eff;
    line-height: 2rem !important;
  }
  .createbox{
    width: 100%;
    text-align: center;
    .createbtn{
      cursor: pointer;
      margin: 10px auto;
      display: block;
      width: 50%;
      background: rgb(64, 158, 255);
      color: rgb(255, 255, 255);
      padding: 10px;
      font-size: 14px;
      border-radius: 5px;
    }
  }
  .tc{
    position: fixed;
    z-index: 100;
    background: rgb(255, 255, 255);
    top: 0px;
    left: 0;
    width: 96%;
    box-sizing: border-box;
    height: 95%;
    border: 1px solid rgb(239, 239, 239);
    border-radius: 10px;
    margin: 2%;
    color: rgb(0, 0, 0);
    text-align: justify;
    line-height: 26px;
    overflow: scroll;
	}
}
</style>

